import { Bank } from '@hub/shared'
import { SetStateAction } from 'react'

export default class PaymentPayloadHelper {
  clearReceiveBank(bank?: Bank | null, paymentType?: string) {
    if (bank) {
      bank.bankAccountAgency = ''
      bank.bankAccountDigit = ''
      bank.bankAccountNumber = ''
      bank.bankAccountType = 'checking'
      bank.bankCode = ''
      bank.bankName = ''
      bank.holderName = ''
      bank.isPersonAccount = 1
      bank.typeOfBusiness = ''

      if (paymentType) {
        bank.paymentType = paymentType
      }
      return bank
    }
  }

  transformNullAndUndefined(bank: Bank) {
    for (const field in bank) {
      if ((bank as any)[field] === null || (bank as any)[field] === undefined) {
        ;(bank as any)[field] = ''
      }
    }

    return bank
  }

  toSetPayload(bank?: Bank, document?: string, documentType?: string): SetStateAction<Bank | null> {
    if (bank?.id) {
      if (bank?.companyOpeningDate) {
        bank.companyOpeningDate = bank?.companyOpeningDate?.split('T')?.[0]
      }
      return this.transformNullAndUndefined(bank)
    }

    return {
      holderDocument: document,
      paymentType: documentType === 'CNPJ' ? 'nf' : 'rpa',
      companyDocument: '',
      bankAccountType: 'checking',
      isPersonAccount: 1,
    } as Bank
  }

  isFormReceiveBankValid(bank: Bank, valid: boolean) {
    return !!(
      valid &&
      bank?.bankCode &&
      [3, 4].includes(bank?.bankAccountAgency?.length) &&
      bank?.bankAccountNumber &&
      ((bank?.paymentType === 'rpa' && bank?.holderName) ||
        (bank?.paymentType === 'nf' &&
          bank?.typeOfBusiness === 'MEI (Microempreendedor Individual)' &&
          bank?.holderDocument &&
          bank?.holderName) ||
        (bank?.paymentType === 'nf' && bank?.typeOfBusiness !== 'MEI (Microempreendedor Individual)'))
    )
  }

  getPayloadBank(bank: Bank, paymentType: string): Partial<Bank> {
    if (paymentType === 'rpa') {
      return this.rpaPayload(bank)
    }
    return this.nfPayload(bank)
  }

  rpaPayload(bank: Bank): Partial<Bank> {
    return {
      bankAccountAgency: bank.bankAccountAgency,
      bankAccountDigit: bank.bankAccountDigit.length >= 1 ? bank.bankAccountDigit : '',
      bankAccountNumber: bank.bankAccountNumber,
      bankAccountType: bank.bankAccountType,
      bankCode: bank.bankCode,
      bankName: bank.bankName,
      holderDocument: bank.holderDocument,
      holderName: bank.holderName,
      isPersonAccount: bank.isPersonAccount,
      nationalDocument: bank.nationalDocument,
      paymentType: bank.paymentType,
      recordEmployment: bank.recordEmployment,
    }
  }

  nfPayload(bank: Bank): Partial<Bank> {
    return {
      bankAccountAgency: bank.bankAccountAgency,
      bankAccountDigit: bank.bankAccountDigit,
      bankAccountNumber: bank.bankAccountNumber,
      bankAccountType: bank.bankAccountType,
      bankCode: bank.bankCode,
      bankName: bank.bankName,
      companyCity: bank.companyCity,
      companyDocument: bank.companyDocument,
      companyLegalNature: bank.companyLegalNature,
      companyName: bank.companyName,
      companyOpeningDate: new Date(bank?.companyOpeningDate),
      companyUf: bank.companyUf,
      holderDocument: bank.holderDocument,
      holderName: bank.holderName,
      holderTradingName: bank.companyName,
      isPersonAccount: bank.isPersonAccount,
      paymentType: bank.paymentType,
      typeOfBusiness: bank.typeOfBusiness,
    }
  }
}
